module.exports = {
  debug: true,
  caiAuthModalEnabled: false,
  userWebComponentsUrl: 'https://use1-user-webcomponents-node-master.awscsusernp.kbb.com/build/node.esm.js',
  caiAuthWebComponentsUrl: 'https://auth-dist.awscconsumerinfo.autotrader.com/prod/v0/cai-authentication-web-components.esm.js',
  ico_EdgeApiUrl: 'https://sandbox.api.kbb.com/ico/v1',
  ico_EdgeApiKey: 'em98w9ayvpbcwcn9k7ag35nx',
  kbbOmnitureSuite: 'kbbbuybkdev',
  gtmTagId: 'GTM-WWTDT3B',
  optimizelySrc: '//cdn.optimizely.com/js/18259871075.js',
  optimizelyKey: 'CKQ7EVdH9LEq66esbR5fb',
  optimizelyEnabled: false,
  caiprivacySrc: 'https://privacy-governance.dataplatform.coxautoinc.com/js/caiprivacy.min.js',
  audioEyeSrc: 'https://ws.audioeye.com/ae.js',
  pixallKbbSrc: 'https://staging.kbb.com/pixall/pix-kbb.min.js',
  pixallAtcSrc: 'https://www.autotrader.com/pixall/pix-at.min.js',
  recaptchaSiteKey: '6Lcw624UAAAAABHAarQigBrISZ8455WfqSKv_0EI',
  recaptchaDisabled: true,
  akamaiStaticPath: 'https://static.kbb.com/icofury/hardening/',
  kbb_Url: 'https://test47.dev.kbb.com',
  ico_directToKBBDealerId: '5ee92276-44b4-47e6-b707-53a1b3344d4b',
  ico_directToKBBDealerIdv2: '725462f5-10f5-4945-ab9b-7f99d5f0d248',
  atc_Url: 'https://www.autotrader.com',
  prefetchYearStart: 0,
  prefetchYearLimit: 1,
  environmentName: 'local',
  optimizely_sdk_key: 'CKQ7EVdH9LEq66esbR5fb',

  // these are only build-time variables, no need to expose to client
  // change requires rebuild
  ...(!process.env.BUILD_STAGE && {
    newRelicApplicationID: '403737885',
    prefetchMakeLimit: 0,
    prefetchModelLimit: 0
  }),
  kbb_global_nav_api: 'https://use1-globalnav-api-master.awskbbcsnp.kbb.com/api/navigation/kbb',
  kbb_global_nav_api_key: 'T6rtXPyqVs61D7gHBdSyz5smR0tofJSY8JzFwsUb'
}
